import { z } from 'zod';
import { userSchema } from './users';

export const bootstrapDataSchema = z.object({
  nonce: z.string().default(''),
  isLoggedIn: z.boolean().default(false),
  user: userSchema.nullable().default(null),
  apiBase: z.string().default(''),
  siteUrl: z.string().default(''),
});

export type BootstrapData = z.infer<typeof bootstrapDataSchema>;
